import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLoginModal from '../components/AdminLoginModal';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(true);

  const handleSuccess = (token) => {
    setShowModal(false);
    navigate('/spoleto/dashboard');
  };

  const handleClose = () => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      navigate('/spoleto/dashboard');
    } else {
      navigate('/');
    }
  };

  if (!showModal) return null;

  return <AdminLoginModal onClose={handleClose} onSuccess={handleSuccess} />;
}
